<div blur="showTree()">
    <terra-text-input
        [inputIsReadonly]="true"
        [inputIsDisabled]="inputIsDisabled"
        inputTooltipText="{{ inputTooltipText }}"
        [inputName]="inputName"
        [(ngModel)]="_categoryName"
        (click)="showTree()"
    >
    </terra-text-input>
    <div *ngIf="toggleTree">
        <terra-node-tree [inputShowSearch]="false" [inputConfig]="_nestedTreeConfig"> </terra-node-tree>
        <terra-base-toolbar>
            <terra-button
                inputTooltipText="{{ 'terraCategoryPicker.select' | translate: _locale.language }}"
                inputTooltipPlacement="top"
                inputIcon="icon-success"
                [inputIsSmall]="true"
                [inputIsDisabled]="_isContainerCategorySelected"
                (outputClicked)="onSelectNode()"
            >
            </terra-button>
            <terra-button
                inputTooltipText="{{ 'cancel' | translate: _locale.language }}"
                inputTooltipPlacement="top"
                inputIcon="icon-cancel"
                [inputIsSmall]="true"
                (outputClicked)="showTree()"
            >
            </terra-button>
            <terra-button
                inputTooltipText="{{ 'terraCategoryPicker.reset' | translate: _locale.language }}"
                inputTooltipPlacement="top"
                inputIcon="icon-reset"
                [inputIsSmall]="true"
                (outputClicked)="reset()"
            >
            </terra-button>
        </terra-base-toolbar>
    </div>
</div>
